<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitMessage">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Teste de mensagens BotConversa
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :disabled="requestingApi"
                    :rules="rules.phoneNumber"
                    v-model="botConversaData.phoneNumber"
                    label="Número de telefone (055 + ddd + número)"
                    clearable
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :disabled="requestingApi"
                    :rules="rules.text"
                    label="Mensagem"
                    v-model="botConversaData.text"
                    counter
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="requestingApi" color="primary" type="submit"
                  ><v-icon class="mr-2">mdi-magnify</v-icon>Enviar</v-btn
                >
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      botConversaData: {
        phoneNumber: null,
        text: null,
      },
      rules: {
        text: [
          (v) => !!v || "Este campo é obrigatório"
        ],
        phoneNumber: [
          (v) => !!v || "Este campo é obrigatório",
          (value) => {
            // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
            const pattern = /^\d{13}$|^\d{14}$/;
            return pattern.test(value) || "Precisa ser um número de telefone válido (13 ou 14 dígitos): 055XX900000000";
          },
        ]
      }
    };
  },
  created() {},
  mounted() {},
  activated() {},
  methods: {
    submitMessage() {
      var vm = this;
      vm.selectedObjects = [];
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.botConversa.sendMessage(vm.botConversaData)
            .then((result) => {
              vm.$notify({
                type: "success",
                text: "Mensagem enviada",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    }
  },
  computed: {},
  watch: { },
};
</script>